// Lightweight pub-sub tracking in-flight API requests so a global top-of-page
// progress bar can react to both route navigation and data fetches, without
// needing every page to wire up its own loading state.
let activeRequests = 0;
const listeners = new Set();

function notify() {
  const isActive = activeRequests > 0;
  listeners.forEach((listener) => listener(isActive));
}

export function startRequest() {
  activeRequests += 1;
  notify();
}

export function endRequest() {
  activeRequests = Math.max(0, activeRequests - 1);
  notify();
}

export function subscribeLoading(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
